export type DashboardUnifiedFilters = {
  search: string;
  client: string;
  type: string;
  status: string;
  product: string;
  startDate: Date;
  endDate: Date;
};

export function createDefaultDashboardFilters(
  now: Date = new Date(),
): DashboardUnifiedFilters {
  return {
    search: "",
    client: "all",
    type: "all",
    status: "all",
    product: "all",
    startDate: new Date(now.getFullYear(), now.getMonth(), 1),
    endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999),
  };
}
